import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { LegExitTypes, MtmCheckType } from "../../../../utProto/webApiStrategyEnums_pb";
import { OhlcInterval } from "../../../../utProto/enums_pb";

export const EXPIRY_WEEKLY_OFFSET_TYPES_STRING = ["0", "1", "2", "3", "4"];
export const EXPIRY_WEEKLY_OFFSET_TYPES_STRING_LABELS = { '0': 'Current', '1': 'Next', '2': 'Far', '3': 'Far + 1', '4': 'Far + 2' };
export const DEFAULT_TAG_LENGTH = 15;
export const SEPARATOR_KEY_CODES = [ENTER, COMMA];
export const MAX_TAGS = 10;
export const PORTFOLIO_NAME_LENGTH = 16;
export const PORTFOLIO_NAME_MAX_LENGTH = 50;
export const CUSTOM_ORDER_EXIT = [MtmCheckType.MTMCHECKTYPE_NET_PNL_ABSOLUTE, MtmCheckType.MTMCHECKTYPE_UNDERLYING, MtmCheckType.MTMCHECKTYPE_UNDERLYING_POINTS, MtmCheckType.MTMCHECKTYPE_DELTA];
export const CUSTOM_ORDER_LEG = [LegExitTypes.LEGEXITTYPES_UNDERLYING_POINTS, LegExitTypes.LEGEXITTYPES_DELTA];
export const STRATEGIES_FIELD = 'strategies';


export const OPERATOR_UNICODES = {
    lessThan: '\u003c',
    greaterThan: '\u003e',
    lessThanOrEqualTo: '\u2264',
    greaterThanOrEqualTo: '\u2265',
    equalTo: '\u003d',
}

export const CandleIntervalsRev = {
    [OhlcInterval.OHLCINTERVAL_1_MIN]: '1m',
    [OhlcInterval.OHLCINTERVAL_3_MIN]: '3m',
    [OhlcInterval.OHLCINTERVAL_5_MIN]: '5m',
    [OhlcInterval.OHLCINTERVAL_10_MIN]: '10m',
    [OhlcInterval.OHLCINTERVAL_15_MIN]: '15m',
    [OhlcInterval.OHLCINTERVAL_30_MIN]: '30m',
    [OhlcInterval.OHLCINTERVAL_1_HOUR]: '1h',
    [OhlcInterval.OHLCINTERVAL_4_HOUR]: '4h',
    [OhlcInterval.OHLCINTERVAL_1_DAY]: '1d',
    [OhlcInterval.OHLCINTERVAL_5_DAYS]: '5d',
    [OhlcInterval.OHLCINTERVAL_1_MONTH]: '1M'
  };

export const StrategyTriggerTypeMap = {
    TargetProfit : 0,
    StopLoss : 1,
    Both : 2
}

export const STTRATEGY_TRIGGER_TYPES = {
    [StrategyTriggerTypeMap.TargetProfit] : "On Target Profit",
    [StrategyTriggerTypeMap.StopLoss] : "On Stop Loss",
    [StrategyTriggerTypeMap.Both] : "Both"
}